import dataPeriVka from "../../../../src/data/periprocedureel-beleid-vka.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriVka,
  BasicSchematic,
  React
};